// src/services/photoService.js

// Mock photo data - simulating Google Photos albums
// In production, this will be replaced with actual Google Photos API calls
const MOCK_PHOTOS = {
    album_kim_chulsoo: [
        {
            id: 'photo1',
            url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=300',
            caption: '작업 전 - 거실 창문',
            date: '2025-02-10',
        },
        {
            id: 'photo2',
            url: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=300',
            caption: '작업 후 - 거실 창문',
            date: '2025-02-10',
        },
        {
            id: 'photo3',
            url: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=300',
            caption: '작업 중 - 안전 장비 착용',
            date: '2025-01-28',
        },
        {
            id: 'photo4',
            url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=300',
            caption: '작업 후 - 베란다 창문',
            date: '2025-01-28',
        },
        {
            id: 'photo10',
            url: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=300',
            caption: '작업 전 - 욕실 창문',
            date: '2025-01-15',
        },
        {
            id: 'photo11',
            url: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=300',
            caption: '작업 후 - 욕실 창문',
            date: '2025-01-15',
        },
        {
            id: 'photo12',
            url: 'https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=300',
            caption: '복도 창문 청소 완료',
            date: '2025-01-15',
        },
    ],
    album_lee_younghee: [
        {
            id: 'photo5',
            url: 'https://images.unsplash.com/photo-1600607688066-890987cbb3e6?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600607688066-890987cbb3e6?w=300',
            caption: '작업 전 - 건물 외벽',
            date: '2025-01-20',
        },
        {
            id: 'photo6',
            url: 'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=300',
            caption: '작업 후 - 건물 외벽',
            date: '2025-01-20',
        },
    ],
    album_park_minsoo: [
        {
            id: 'photo7',
            url: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=300',
            caption: '상가 간판 청소 - 작업 전',
            date: '2025-01-22',
        },
        {
            id: 'photo8',
            url: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=300',
            caption: '상가 간판 청소 - 작업 후',
            date: '2025-01-22',
        },
        {
            id: 'photo9',
            url: 'https://images.unsplash.com/photo-1600563438938-a2f902e49929?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1600563438938-a2f902e49929?w=300',
            caption: '어닝 청소 완료',
            date: '2025-01-22',
        },
    ],
    album_business_user: [
        {
            id: 'biz_photo1',
            url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=300',
            caption: '메인 로비 - 작업 후',
            date: '2025-02-15',
        },
        {
            id: 'biz_photo2',
            url: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=300',
            caption: '회의실 유리벽 - 작업 후',
            date: '2025-02-15',
        },
        {
            id: 'biz_photo3',
            url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=300',
            caption: '휴게 공간 - 작업 전',
            date: '2025-02-14',
        },
        {
            id: 'biz_photo4',
            url: 'https://images.unsplash.com/photo-1556761175-4b46a891931e?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1556761175-4b46a891931e?w=300',
            caption: '휴게 공간 - 작업 후',
            date: '2025-02-14',
        },
        {
            id: 'biz_photo5',
            url: 'https://images.unsplash.com/photo-1504384308090-c54be3855833?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1504384308090-c54be3855833?w=300',
            caption: '오피스 전경',
            date: '2025-02-14',
        },
        {
            id: 'biz_photo6',
            url: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=300',
            caption: '임원실 창문',
            date: '2025-02-13',
        },
    ],
};

export const getPhotosByAlbumId = (albumId) => {
    return new Promise((resolve, reject) => {
        // Simulate API delay
        setTimeout(() => {
            const photos = MOCK_PHOTOS[albumId];
            if (photos) {
                resolve(photos);
            } else {
                reject(new Error('사진을 찾을 수 없습니다.'));
            }
        }, 800);
    });
};
